import { doc, setDoc } from 'firebase/firestore'
import { database } from '../config'
import uuid from 'react-uuid'

export const saveContact = async (info: any) => {
    await setDoc(doc(database, 'contact', uuid()), info)
}
